'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
export const FilterGroupTypes = {
  EMPTY: 'empty',
  AUDIENCES: 'audiences',
  DETAILED_TARGETING: 'detailedTargeting',
  MIXED: 'mixed'
};
const FilterGroupRecord = Record({
  type: FilterGroupTypes.EMPTY,
  audiences: ImmutableSet(),
  detailedTargeting: ImmutableSet()
});
export default FilterGroupRecord;